export default __webpack_public_path__ + "static/media/exit_box.6323542c.svg";